import {
    GET_CLASSSESSION,
    GET_SPLIST,
    GEN_CLASSSESSION,
    DELETE_CLASSSESSION,
    UPDATE_CLASSSESSION,
    RESET_CLASSSESSION
  } from "../actionTypes";


const classSessionReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CLASSSESSION:
      return action.payload;

    case GET_SPLIST:
      return action.payload; 

    case GEN_CLASSSESSION:
      return action.payload;

    case UPDATE_CLASSSESSION:
      return state.map(item =>
        item.id === action.payload.id ? action.payload : item
      );

    case DELETE_CLASSSESSION:
      return {
        ...state,
        users: state.users.map(item =>
          item.userId === action.payload.userId ? action.payload : item
        )
      };

    case RESET_CLASSSESSION:
      return null;

    default:
      return state;
  }
};

export default classSessionReducer;